import script from "./RouteIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./RouteIndex.vue?vue&type=script&lang=ts&setup=true"

import "./RouteIndex.vue?vue&type=style&index=0&id=0fb0d44a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb0d44a"]])

export default __exports__